module.exports = __webpack_public_path__ + "static/media/tempted_red.aee8a0fa.png";